import React from 'react';
import { IErrorBoundaryProps, IErrorBoundaryState } from './ErrorBoundary.types';

class ErrorBoundary extends React.Component<IErrorBoundaryProps, IErrorBoundaryState> {
  // eslint-disable-next-line react/static-property-placement
  static defaultProps = {
    fallback: <div />
  };

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
  }

  render() {
    const { state, props } = this;
    if (state.hasError) {
      return props.fallback;
    }

    return props.children;
  }
}

export default ErrorBoundary;
